
import { SyntheticEvent, useEffect, useState } from 'react'
import appInfo from '../../../configs/app-info';
import apiUrl from '../../../configs/constant';
import { getDoctag, getCustomer, getSales, getDesigner, getProduct } from '../../../api/helper';
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Swal from 'sweetalert2'
import axios from 'axios'
import { Controller, useForm } from 'react-hook-form'
import { Autocomplete, Box, Button, Divider, Fab, FormControl, FormHelperText, IconButton, TextField, Tooltip } from '@mui/material';
import MsiDatagrid from '../../custom/MsiDatagridAuto';
import Icon from '../../icon';
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import { useToast } from '../../ToastProvider';

interface Props {
    id: any
    onClose: () => void
}

const terbilang = (nominal: number) => {
    if (isNaN(nominal) || nominal < 0) return 'Nominal tidak valid'

    const satuan = ['', 'SATU', 'DUA', 'TIGA', 'EMPAT', 'LIMA', 'ENAM', 'TUJUH', 'DELAPAN', 'SEMBILAN', 'SEPULUH', 'SEBELAS']

    const penyebut = (n: number): string => {
        if (n < 12) return satuan[n]
        if (n < 20) return `${penyebut(n - 10)} BELAS`
        if (n < 100) return `${penyebut(Math.floor(n / 10))} PULUH ${penyebut(n % 10)}`
        if (n < 200) return `SERATUS ${penyebut(n - 100)}`
        if (n < 1000) return `${penyebut(Math.floor(n / 100))} RATUS ${penyebut(n % 100)}`
        if (n < 2000) return `SERIBU ${penyebut(n - 1000)}`
        if (n < 1000000) return `${penyebut(Math.floor(n / 1000))} RIBU ${penyebut(n % 1000)}`
        if (n < 1000000000) return `${penyebut(Math.floor(n / 1000000))} JUTA ${penyebut(n % 1000000)}`
        if (n < 1000000009) return `${penyebut(Math.floor(n / 1e9))} MILIAR ${penyebut(n % 1e9)}`
        return 'Angka terlalu besar'
    }

    const result = penyebut(Math.floor(nominal))?.replace(/\s+/g, ' ').trim() || ''

    return `${result} RUPIAH`
}

export default function DetailDO({ id }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const [listDetail, setListDetail] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [openDialogSalesOrder, setOpenDialogSalesOrder] = useState<boolean>(false)
    const [listSalesOrder, setListSalesOrder] = useState<any[]>([])
    const [editDetail, setEditDetail] = useState<boolean>(false)

    const [openDialogKurirResi, setOpenDialogKurirResi] = useState<boolean>(false)

    useEffect(() => {
        getData()
        getDetail()
        // fetchCombo('/mm/jenis-barang/list-combo', setJenisOptions)
    }, [])


    const fetchCombo = (endpoint: string, setter: (data: any[]) => void) => {
        axios
            .get(apiUrl.apiUrl + endpoint, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(res => {
                if (res.data.success) setter(res.data.data)
            })
    }
    const getListSalesOrder = () => {
        const sdsoId = getValues('sdso_id');
        const url = apiUrl.apiUrl + '/sales/delivery-order/list-open-sales-order'
        axios
            .get(url, {
                params: { sdsoId: sdsoId },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSalesOrder(data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    // Komponen kecil untuk 1 item informasi
    const InfoItem = ({ label, value }: { label: string; value: string | number }) => (
        <Box sx={{ mb: 1.5 }}>
            <Typography
                sx={{ fontSize: 13, fontWeight: 600, color: "text.secondary", mb: 0.3 }}
            >
                {label}
            </Typography>
            <Typography>
                {value || "-"}
            </Typography>
        </Box>
    );

    const rowClickSalesOrder = (e: any) => {
        const data = e.data
        setOpenDialog(false)

        const payload = {
            sddo_id: id,
            sdso_d_id: data.id,
        }
        const url = apiUrl.apiUrl + '/sales/delivery-order/add-so-detail'
        axios
            .post(url, payload, {
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data[0]

                    showToast(response.data.message, 'success');
                    getData()
                    getDetail(); // Refresh the detail list
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const getDetail = () => {
        const url = apiUrl.apiUrl + '/sales/delivery-order/detail-item/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    setListDetail(response.data.data)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const getData = () => {
        const url = apiUrl.apiUrl + '/sales/delivery-order/detail/' + id
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setValue('syscabang_id', data.syscabang_id)
                    setValue('sysdoctag_id', data.sysdoctag_id)
                    setValue('sdso_id', data.sdso_id)
                    setValue('dokumen', data.dokumen)
                    setValue('mmgudang_id', data.mmgudang_id)
                    setValue('gudang', data.gudang)
                    setValue('tgl', data.tgl)
                    setValue('tgl_kirim', data.tgl_kirim)
                    setValue('resi', data.resi)
                    setValue('kurir', data.kurir)
                    setValue('nama_customer', data.nama_customer)
                    setValue('pic', data.pic)
                    setValue('alamat_kirim', data.alamat_kirim)
                    setValue('keterangan', data.keterangan)
                } else {
                    showToast(response.data.message, 'error');
                }
            })
    }

    const resetDetail = () => {
        setValue('sddoDId', 0)
        setValue('qtyDetail', '')
        setValue('keteranganDetail', '')
        setValue('namaProductDetail', '')
        setValue('kodeProductDetail', '')
    }

    interface FormInputs {
        syscabang_id: number;
        sysdoctag_id: number;
        dokumen: string;
        mmgudang_id: number;
        gudang: string;
        tgl: string;
        tgl_kirim: string;
        nama_customer: string;
        pic: string;
        alamat_kirim: string;
        keterangan: string;
        sdso_id: number;
        sdso_d_id: number;
        resi: any
        kurir: any
        sddoDId: number;
        qtyDetail: any;
        keteranganDetail: string;
        namaProductDetail: string;
        kodeProductDetail: string;
    }

    const defaultValues = {
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const ActionButtons = ({ row, onDelete }: {
        row: any;
        onDelete: (row: any) => void;
    }) => {
        const actions = [
            {
                title: "Edit Detail",
                icon: "mdi:pencil",
                color: "primary",
                onClick: () => {
                    resetDetail();
                    setValue('sddoDId', row.id);
                    setValue('sdso_d_id', row.sdso_d_id);
                    setValue('qtyDetail', row.qty);
                    setValue('keteranganDetail', row.keterangan);
                    setValue('namaProductDetail', row.nama);
                    setValue('kodeProductDetail', row.kode);
                    setOpenDialogSalesOrder(true);
                    setEditDetail(true);
                }
            },
            {
                title: "Hapus Delivery Order",
                icon: "mdi:trash",
                color: "primary",
                onClick: () => onDelete(row)
            }
        ];
        return (
            <Box sx={{ display: "flex", alignItems: "center" }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement="top">
                        <IconButton onClick={action.onClick}>
                            <Icon icon={action.icon} color={action.color} />
                        </IconButton>
                    </Tooltip>
                ))}
            </Box>
        );
    };

    const handleDelete = (row: any) => {
        const url = apiUrl.apiUrl + '/sales/delivery-order/delete-sddo-d/' + row.id
        axios
            .delete(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
            .then(response => {
                if (response.data.success) {
                    showToast(response.data.message, 'success');
                    getDetail()
                    getData()
                } else {
                    showToast(response.data.message, 'error');
                }
            })
            .catch(error => {
                showToast(error.message, 'error');
            })
    }

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 100,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                />
            ),
        },
    ];

    return (
        <>
            <form>
                <Grid container spacing={2} sx={{ ml: 3, mt: 1 }}>
                    <Grid item xs={12} md={6}>
                        <InfoItem label="Dokumen" value={watch("dokumen")} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <InfoItem label="Gudang" value={watch("gudang")} />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <InfoItem label="Tanggal" value={watch("tgl")}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <InfoItem label="Tanggal Kirim" value={watch("tgl_kirim")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InfoItem label="PIC" value={watch("pic")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <InfoItem label="Nama Customer" value={watch("nama_customer")} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, mb: 2 }}>
                            <InfoItem label="Resi" value={watch("resi")} />
                            <IconButton color="primary" size="small" onClick={() => {
                                setOpenDialogKurirResi(true)
                            }}>
                                <Icon icon="mdi:pencil" />
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-start', gap: 2, mb: 2 }}>
                            <InfoItem label="Kurir" value={watch("kurir")} />
                            <IconButton color="primary" size="small" onClick={() => {
                                setOpenDialogKurirResi(true)
                            }}>
                                <Icon icon="mdi:pencil" />
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <InfoItem label="Alamat Kirim" value={watch("alamat_kirim")} />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <InfoItem label="Keterangan" value={watch("keterangan")} />
                    </Grid>
                </Grid>
            </form>
            <Divider sx={{ mt: 3 }} />
            <Box sx={{ mt: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, mb: 2 }}>
                    <Button variant="contained" color="primary"
                        onClick={() => {
                            resetDetail()
                            setEditDetail(false)
                            getListSalesOrder()
                            setOpenDialog(true)
                        }}>
                        Tambah Sales Order Detail
                    </Button>
                </Box>
                <Typography variant="h6" sx={{ mb: 2, textAlign: 'center' }}>
                    LIST DELIVERY ORDER ITEM
                </Typography>
                <Box sx={{ overflowX: 'auto' }}>
                    <MsiDatagrid key={1} array={listDetail} actions={actionData} />
                </Box>
            </Box>


            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title'>
                    <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                        Tambah Sales Order
                    </Typography>
                </DialogTitle>
                <DialogContent dividers sx={{ p: 2 }}>
                    <Grid container spacing={3}>
                        <MsiDatagrid array={listSalesOrder} rowClick={rowClickSalesOrder} />
                    </Grid>
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                maxWidth={'lg'}
                fullWidth={true}
                open={openDialogSalesOrder}
                onClose={() => setOpenDialogSalesOrder(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = '';
                    if (editDetail) {
                        url = apiUrl.apiUrl + '/sales/delivery-order/edit-sales-order/' + data.sddoDId;
                    } else {
                        url = apiUrl.apiUrl + '/sales/delivery-order/save-sales-order/' + id;
                    }

                    axios.post(url, {
                        id: editDetail ? data.sddoDId : data.sdso_d_id,
                        qty: data.qtyDetail,
                        notes: data.keteranganDetail,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');

                                setOpenDialogSalesOrder(false);
                                getDetail(); // Refresh the detail list
                                getData(); // Refresh the main data
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialogSalesOrder(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Tambah Sales Order
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            {editDetail ?
                                <Grid item xs={12} md={12}>
                                    <FormControl fullWidth>
                                        <Controller
                                            name='sddoDId'
                                            control={control}
                                            render={({ field: { value, onChange } }) => (
                                                <TextField
                                                    value={value}
                                                    label='ID Detail'
                                                    type='number'
                                                    InputLabelProps={{ shrink: true }}
                                                    onChange={onChange}
                                                    InputProps={{ readOnly: true }} // Make the input read-only
                                                />
                                            )}
                                        />
                                    </FormControl>
                                </Grid> : null}
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='namaProductDetail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Nama Product'
                                                type='text'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                InputProps={{ readOnly: true }} // Make the input read-only
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kodeProductDetail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Kode Product'
                                                type='text'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                InputProps={{ readOnly: true }} // Make the input read-only
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='qtyDetail'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Qty'
                                                type='number'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.qtyDetail)}
                                            />
                                        )}
                                    />
                                    {errors.qtyDetail && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Qty harus diisi</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keteranganDetail'
                                        control={control}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                multiline
                                                rows={4}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>

                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogSalesOrder(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialogKurirResi}
                onClose={() => setOpenDialogKurirResi(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = apiUrl.apiUrl + '/sales/delivery-order/edit-kurir-resi/' + id;

                    axios.post(url, {
                        kurir: data.kurir,
                        resi: data.resi
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialogKurirResi(false);
                                getData();
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialogKurirResi(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Edit Kurir dan Resi
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='resi'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Resi'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.resi)}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='kurir'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Kurir'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                                error={Boolean(errors.kurir)}
                                            />
                                        )}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialogKurirResi(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    )
}
